import { useTranslation } from 'react-i18next';
import {
  MonthPicker as UiMonthPicker,
  type MonthPickerProps as UiMonthPickerProps,
} from '@repo/ui/src/components/month-picker';

export type MonthPickerProps = UiMonthPickerProps;

/** Dashboard-bound MonthPicker: i18n placeholder + year-nav labels. */
export function MonthPicker({ placeholder, prevYearLabel, nextYearLabel, ...rest }: MonthPickerProps) {
  const { t } = useTranslation('common');
  return (
    <UiMonthPicker
      {...rest}
      placeholder={placeholder ?? t('picker.selectMonth')}
      prevYearLabel={prevYearLabel ?? t('picker.prevYear')}
      nextYearLabel={nextYearLabel ?? t('picker.nextYear')}
    />
  );
}
